import { cloneDeep, isEqual } from 'lodash'

// Контракт миксина.
// `proxy` разделяет ссылку со свойством `value`: `receiveValue` присваивает результат
// входного фильтра без клонирования, поэтому мутация `proxy` меняет и источник.
// Событие `input` отправляется на каждое изменение `proxy`, без проверки на равенство.
// Если входной или выходной фильтр компонента возвращает новую ссылку, а родитель
// на `input` пишет значение обратно в источник `value`, обмен зацикливается.
// Проверка на равенство в таком случае - зона ответственности компонента: он перебивает
// `transmitValue` и сравнивает результат выходного фильтра со свойством `value`.
export const proxy = (options = {}) => {
  const { type, defaultValue } = options

  const props = {
    value: {
      type: null,
      default: defaultValue
    },

    defaultValue: {
      type: null,
      default: defaultValue
    }
  }

  const data = function() {
    return {
      proxy: this._inputFilter(cloneDeep(this.value)) || cloneDeep(defaultValue),
      initProxy: undefined
    }
  }

  const computed = {
    proxyIsChanged() {
      return !isEqual(JSON.stringify(this.proxy), JSON.stringify(this.initProxy))
    }
  }

  const watch = {
    value: {
      handler() {
        this.watchValueHandler()
      }
    },
    proxy: {
      handler() {
        this.watchProxyHandler()
      }
    }
  }

  const mounted = function() {
    this.receiveValue()
  }

  const methods = {
    _inputFilter(value) {
      return value
    },
    _outputFilter(value) {
      return value
    },

    receiveValue() {
      this.proxy = this._inputFilter(this.value)
      this.initProxy = cloneDeep(this.proxy)
    },
    transmitValue() {
      this.$emit('input', this._outputFilter(this.proxy))
    },

    watchValueHandler() {
      this.receiveValue()
    },
    watchProxyHandler() {
      this.transmitValue()
    }
  }

  switch (type) {
    case 'string': {
      props.value.type = String
      props.defaultValue.type = String
      break
    }
    case 'number': {
      props.value.type = Number
      props.defaultValue.type = Number
      break
    }
    case 'boolean': {
      props.value.type = Boolean
      props.defaultValue.type = Boolean
      break
    }
    case 'array': {
      props.value.type = Array
      props.value.default = () => {
        return defaultValue || []
      }
      props.defaultValue.type = Array
      props.defaultValue.default = () => {
        return defaultValue || []
      }
      watch.value.deep = true
      watch.proxy.deep = true
      break
    }
    case 'object': {
      props.value.type = Object
      props.value.default = () => {
        return defaultValue || {}
      }
      props.defaultValue.type = Object
      props.defaultValue.default = () => {
        return defaultValue || {}
      }
      watch.value.deep = true
      watch.proxy.deep = true
      break
    }
  }

  return {
    props,
    data,
    computed,
    watch,
    mounted,
    methods
  }
}
